export const ApiTagsEnum = {
  DEVELOPER      : "Developer",
  REPORTS        : "Reports",
  USERS          : "Users",
  HIRING_DEV     : "HiringDev",
  SCOPES         : "Scopes",
  INVOICES       : "Invoices",
  COMPANIES      : "Companies",
  DAY_OFFS       : "DayOffs",
  PROJECTS       : "Projects",
  BANK_DETAILS   : "BankDetails",
  SKILLS         : "Skills",
  CLIENT_REQUESTS: "ClientRequests",
  CLIENT_CALLS   : "ClientCalls",
  COMPANY_NOTES  : "CompanyNotes",
  GIT_TOKEN      : "GitToken",
  GIT_HISTORY    : "GitHistory",
  MEETINGS       : "Meetings",
} as const;

export const ALL_API_TAGS = Object.values(ApiTagsEnum);
